import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SectionHeader = styled.h3<{smallMargin?: boolean}>`
  margin-bottom: ${p => (p.smallMargin ? 8 : 16)}px;
  opacity: 0.7;
`;

export const SectionHeaderPill = styled.div<{smallMargin?: boolean}>`
  margin-bottom: ${p => (p.smallMargin ? 8 : 16)}px;
  margin-left: 10px;
`;

export const AlignedSection = styled.div`
  display: flex;
  align-items: center;
`;

export const SectionSubheader = styled.div<{smallMargin?: boolean}>`
  font-size: 14px;
  color: ${globals.gray600};
  margin-bottom: ${p => (p.smallMargin ? 8 : 16)}px;
`;

export const UpgradeModalLink = styled.div`
  color: ${globals.TEAL_500};
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: ${globals.TEAL_600};
  }
`;
